module.exports = __webpack_public_path__ + "3c5a03417ac954ebb4f7ffe8c0721e97.pdf";